import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
import "./Dashboard.less"
import ReactJson from "react-json-view"
import { withRouter } from "../../lib/withRouter"
import ViewClaimReviewHeader from "./ViewClaimReviewHeader"
import Header2 from "../Header2"
import { getQuickSightUrl, getViewPatientData } from "../../lib"
import moment from "moment"
import RangePicker from "./RangePicker"
import ClaimTab from "./ClaimTab"
import { ApproveTab } from "./ApproveTab"
import { UnapproveTab } from "./Unapproved"

export class ClaimReview extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            activeTab: "claim"
        };
    }

    /** Callback to handle tab changes from ViewHeader */
    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
        this.props.dispatch(setParam("_resource", tabName));
    };

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

        const _resource = query.get("_resource");
        if (["claim", "approved", "unapproved"].includes(_resource)) {
            this.setState({ activeTab: _resource });
        }
    }

    render() {
        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />

                    <ViewClaimReviewHeader
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        activeTab={this.state.activeTab}
                        onTabChange={this.handleTabChange}
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderTabContent()}
                </div>
            </div>
        )
    }

    renderTabContent() {
        const { activeTab } = this.state;

        switch (activeTab) {
            case "claim":
                return <ClaimTab
                    query={this.props.query}
                    settings={this.props.settings}
                    location={this.props.location}
                    urlParams={this.props.urlParams}
                    activeTab={this.state.activeTab}
                />;
            case "approved":
                return <ApproveTab
                    query={this.props.query}
                    settings={this.props.settings}
                    location={this.props.location}
                    urlParams={this.props.urlParams}
                    activeTab={this.state.activeTab}
                />;
            case "unapproved":
                return <UnapproveTab
                    query={this.props.query}
                    settings={this.props.settings}
                    location={this.props.location}
                    urlParams={this.props.urlParams}
                    activeTab={this.state.activeTab}
                />;
        }
    }
}

export default connect(state => state)(withRouter(ClaimReview));
